<template>
    <b-card no-body>    
        <!-- preview modal -->
        <PreviewApprovalModal ref="previewApprovalModal" :approval="current_approval" @preview-value="previewValue" />
        <!-- decide modals-->
        <PendingApprovalCaseModal ref="pendingApprovalCaseModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>
        <PendingApprovalPersonalLoanModal ref="pendingApprovalPersonalLoanModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>
        <PendingApprovalMortgageLoanModal ref="pendingApprovalMortgageLoanModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>
        <PayoutDetailsModal 
            :showDirectPayoutDetails.sync="modals.showDirectPayoutDetails" 
            :current_comms_payout_summaries="current_comms_payout_summaries"
            :comms_payout_summaries="comms_payout_summaries"
            :hub_pending_approval="current_approval"
            @close-modal="modals.showDirectPayoutDetails=false"
            :decide_mode="decide_mode"
            :permission="permission"
            @refresh-approval="getPendingApprovals"
            @update-comms-payout-summaries="getUpdatedCommsPayoutSummaries"
        />
        <CancelApprovalHubCommsPayoutSummaryModal ref="cancelApprovalHubCommsPayoutSummaryModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>
        <PendingApprovalInsuranceModal ref="pendingApprovalInsuranceModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>
        <PendingApprovalRefinanceModal ref="pendingApprovalRefinanceModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>
        <PendingApprovalOtherLoanModal ref="pendingApprovalOtherLoanModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>
        <PendingApprovalSolicitorModal ref="pendingApprovalSolicitorModal" :approval="current_approval" @refresh-approval="getPendingApprovals"/>

        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <b-row align-v="center" class="px-3 mb-4 mx-0">
            <b-col cols="6" md="auto" class="px-1" v-for="(status, index) in approval_statuses" :key="index">
                <b-button 
                    block
                    variant="outline-primary"
                    :class="getFilterStatusClass(status)"
                    :pressed="selectedStatus === status"
                    @click="selectFilterButton(status)"
                    class="mb-2 mr-2 shadow-none"
                >
                    {{ status }}<br>
                    <span class="font-weight-600">{{ totalApprovalStatus[status.toLowerCase()] }}</span>
                </b-button>
            </b-col>
        </b-row>

        <b-row align-v="center" class="mx-0">
            <b-col cols="12" md="auto">
                <base-input
                v-model="searchQuery"
                v-on:input="debouncedHandler"
                prepend-icon="fas fa-search"
                placeholder="Search..."
                >
                </base-input>
            </b-col>
            <b-col cols="12" md="7">
                <b-row align-h="center" class="px-3 mb-4">
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none" :pressed="activeTab === 'all'" @click="changeTable('all')">All</b-button>
                    </b-col>
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none" :pressed="activeTab === 'cases'" @click="changeTable('cases')">Cases</b-button>
                    </b-col>
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none" :pressed="activeTab === 'revenue'" @click="changeTable('revenue')" disabled>Revenue</b-button>
                    </b-col>
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none" :pressed="activeTab === 'commission'" @click="changeTable('commission')">Comm</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>


        <!-- TABLE LIST -->
        <div class="table-listings px-3">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"

                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    fixed="left"
                ></el-table-column>
    
                <el-table-column
                    prop="appr_related_id"
                    label="Title"
                    min-width="180"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="top-line text-break">{{ scope.row.appr_content.replace(/Approval \#\d+/, '') | formatUserName(15) }}</p>
                        <p class="bottom-line text-break">{{ scope.row.appr_related_id }}</p>
                    </template>
                </el-table-column>
    
                <el-table-column
                    label="Customer"
                    min-width="220"
                    sortable
                >
                    <template slot-scope="scope">
                        <!-- Customer Name -->
                        <el-tooltip v-if="scope.row.appr_req_value.prod_customer_name" effect="dark" :content="scope.row.appr_req_value.prod_customer_name" placement="bottom">
                            <p v-if="scope.row.appr_req_value.prod_customer_name" class="top-line text-break">{{ scope.row.appr_req_value.prod_customer_name | formatUserName(25) }}</p>
                        </el-tooltip>

                        <el-tooltip v-else-if="_gHlp.getValue(scope.row,'appr_req_value.0.case')" effect="dark" :content="_gHlp.getValue(scope.row,'appr_req_value.0.case.prod_customer_name')" placement="bottom">
                            <p  class="top-line text-break">{{ _gHlp.getValue(scope.row,'appr_req_value.0.case.prod_customer_name') | formatUserName(25) }}</p>
                        </el-tooltip>

                        <!-- Customer ID -->
                        <p v-if="scope.row.appr_req_value.prod_customer_id" class="bottom-line text-break">{{ scope.row.appr_req_value.prod_customer_id }}</p>
                        <p v-else-if="_gHlp.getValue(scope.row,'appr_req_value.0.case')" class="bottom-line text-break">{{ _gHlp.getValue(scope.row,'appr_req_value.0.case.prod_customer_id') }}</p>
                    </template>
                </el-table-column>
    
                <el-table-column
                    label="Loan Amount"
                    min-width="180"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="top-line" v-if="scope.row.approval_type === 'PL_APPROVAL'">
                            RM {{ scope.row.appr_req_value.product_detail.prod_pl_loan_amount | moneyFormatter }}
                        </p>
                        <p class="top-line" v-else-if="scope.row.approval_type === 'REF_APPROVAL'">
                            RM {{ scope.row.appr_req_value.product_detail.prod_ref_loan_amount | moneyFormatter }}
                        </p>
                        <p class="top-line" v-else-if="scope.row.approval_type === 'OTH_LOAN_APPROVAL'">
                            RM {{ scope.row.appr_req_value.product_detail.prod_oth_value | moneyFormatter }}
                        </p>
                        <span v-else class="bg-fintos font-weight-500 px-2">WIP</span>
                    </template>
                </el-table-column>

                <!-- <el-table-column
                 label="Reviewers"
                 min-width="250"
                >
                    <template slot-scope="scope">
                        <div v-for="(groupReviewers, index) in 
                            Object.values(scope.row.approval_reviewers.reduce((result, item) => ((result[item.app_rev_order] = [...(result[item.app_rev_order] || []), item]), result), {}))" 
                            :key="index"
                        >
                            <span v-for="(reviewer,index) in groupReviewers" :key="index">
                                <span class="mr-2">
                                    <span v-if="reviewer.appr_rev_status === null"><i class="fa fa-clock text-warning"></i></span>
                                    <span v-if="reviewer.appr_rev_status === 1"><i class="fa fa-check-circle text-success"></i></span>
                                    <span v-if="reviewer.appr_rev_status === 0"><i class="fa fa fa-times-circle text-danger"></i></span>
                                    <span> {{ reviewer.appr_rev_user_detail.name }}</span> 
                                </span>
                            </span>
                        </div>
                    </template>
                </el-table-column> -->

                <el-table-column
                 label="Reviewers"
                 min-width="150"
                >
                    <template slot-scope="scope">
                        <div class="d-flex align-items-center">
                            <div v-for="(reviewersStatus, index) in groupingReviewers(scope.row.approval_reviewers)" 
                                :key="index"
                            >

                                <div v-if="scope.row.appr_related_type !== 'case_recognizes'">
                                    <el-tooltip effect="dark" :content="getReviewerName(index)" placement="bottom">
                                        <svg id="status-svg" width="40" height="40">
                                            <circle cx="20" cy="20" r="15" :fill="getStatusFill(reviewersStatus)" />
                                            <text x="20" y="26" text-anchor="middle" fill="#fff" class="reviewer-text">{{ getReviewerInitial(index) }}</text>
                                        </svg>
                                    </el-tooltip>
                                </div>
                                <div v-else>
                                    <el-tooltip effect="dark" :content="getHubReviewerName(index)" placement="bottom">
                                        <svg id="status-svg" width="40" height="40">
                                            <circle cx="20" cy="20" r="15" :fill="getStatusFill(reviewersStatus)" />
                                            <text x="20" y="26" text-anchor="middle" fill="#fff" class="reviewer-text">{{ getHubReviewerInitial(index) }}</text>
                                        </svg>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="created_by"
                    label="Created By"
                    min-width="110"
                    align="center"
                >
                    <template slot-scope="scope">
                        <!-- <p>{{ scope.row.created_by_detail.name | formatUserName(20) }}</p> -->
                        <el-tooltip effect="dark" :content="scope.row.created_by_detail.name" placement="bottom">
                            <b-avatar size="32px" :src="scope.row.created_by_detail.name" :text="_gHlp.formatInitials(scope.row.created_by_detail.name)"></b-avatar>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="created_at"
                    label="Created At"
                    min-width="150"
                    sortable
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.created_at">
                            {{ scope.row.created_at | dateFormatString }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="appr_final_status"
                    label="Status"
                    min-width="150"
                    sortable
                >
                    <template slot-scope="scope">
                        <svg id="status-svg" width="50" height="50" v-if="scope.row.appr_final_status === null">
                            <circle cx="25" cy="25" r="18" fill="#f3bc43" />
                            <text x="25" y="33" text-anchor="middle" fill="#fff" class="cases-text">P</text>
                        </svg>
                        <svg id="status-svg" width="50" height="50" v-if="scope.row.appr_final_status === 1">
                            <circle cx="25" cy="25" r="18" fill="#2dce89" />
                            <text x="25" y="33" text-anchor="middle" fill="#fff" class="cases-text">A</text>
                        </svg>
                        <svg id="status-svg" width="50" height="50" v-if="scope.row.appr_final_status === 0">
                            <circle cx="25" cy="25" r="18" fill="#f5365c" />
                            <text x="25" y="33" text-anchor="middle" fill="#fff" class="cases-text">R</text>
                        </svg>
                        <svg id="status-svg" width="50" height="50" v-if="scope.row.appr_final_status === 2">
                            <circle cx="25" cy="25" r="18" fill="#00000" />
                            <text x="25" y="33" text-anchor="middle" fill="#fff" class="cases-text">C</text>
                        </svg>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Actions"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <div class="d-flex">
                            <el-button class="bg-primary text-white p-2" 
                                @click="previewApproval(scope.row)"
                                >Preview
                            </el-button>
                            <el-button class="bg-fintos text-dark p-2" 
                            v-if="scope.row.next_approval_reviewers.length > 0 &&
                                scope.row.next_approval_reviewers.some(reviewer => reviewer.appr_rev_user_id === auth_user.id)"
                                @click="decideApproval(scope.row)"
                                >Decide
                            </el-button>
                            <el-button class="bg-fintos text-dark p-2" 
                            v-if="scope.row.appr_final_status === 1 && scope.row.approval_type == 'HUB_COMMS_PAYOUT_SUMMARY_APPROVAL'"
                                @click="cancelCase(scope.row)"
                                >Cancel
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>

    </b-card>
</template>

<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem, Tooltip } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'
import PendingApprovalCaseModal from './PendingApprovalModals/PendingApprovalCaseModal.vue';
import PreviewApprovalModal from './PendingApprovalModals/PreviewApprovalModal.vue';
import PendingApprovalPersonalLoanModal from './PendingApprovalModals/PendingApprovalPersonalLoanModal.vue';
import PendingApprovalRefinanceModal from './PendingApprovalModals/PendingApprovalRefinanceModal.vue';
import PendingApprovalMortgageLoanModal from './PendingApprovalModals/PendingApprovalMortgageLoanModal.vue';
import PayoutDetailsModal from "@/views/Commission/Hub/HubProfile/CenterProfileDetails/PayoutDetailsModalV2.vue";
import PendingApprovalInsuranceModal from './PendingApprovalModals/PendingApprovalInsuranceModal.vue';
import PendingApprovalOtherLoanModal from './PendingApprovalModals/PendingApprovalOtherLoanModal.vue';
import PendingApprovalSolicitorModal from './PendingApprovalModals/PendingApprovalSolicitorModal.vue';
import CancelApprovalHubCommsPayoutSummaryModal from './PendingApprovalModals/CancelApprovalHubCommsPayoutSummaryModal.vue';
import { useApprovalStore } from '@/stores/approvalStore'
import {APPROVALS_STATUS} from '@/assets/js/status.js'
import { MANAGER_ROLE_IDS } from '@/assets/js/roles.js' 

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        PendingApprovalOtherLoanModal,
        PreviewApprovalModal,
        PendingApprovalCaseModal,
        PendingApprovalPersonalLoanModal,
        PendingApprovalMortgageLoanModal,
        PendingApprovalInsuranceModal,
        PendingApprovalRefinanceModal,
        PendingApprovalSolicitorModal,
        CancelApprovalHubCommsPayoutSummaryModal,
        PayoutDetailsModal,
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Tooltip.name]: Tooltip,
    },
    data() {
        return {
            isTableLoading: true,
            propsToSearch:['appr_related_id'],
            currentPage: 1,
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            status_data: {},
            pagination:{
                perPageOptions: [5, 10, 25, 50, 100, 500]
            },
            is_loading_review: false,
            current_approval: null,
            // hub comms payout
            MANAGER_ROLE_IDS: MANAGER_ROLE_IDS,
            modals:{
                showDirectPayoutDetails: false,
            },
            current_comms_payout_summaries: [],
            comms_payout_summaries: [],
            decide_mode: false,
            permission: {
                acceptor: false,
                reviewer: false,
                approver: false,
                admin: false,
            },
            is_first_load: true,
            activeTab: 'all',
            allApprovals: [],
            productsApprovals: [],
            commissionApprovals: [],
            approval_statuses: APPROVALS_STATUS,
            selectedStatus: 'All',
            totalApprovalStatus: {
                all: 0,
                pending: 0,
                approved: 0,
                rejected: 0
            }
        }
    },
    computed:{
        ...mapState(useAuthStore, ['auth_user']),
    },
    created(){
        this.getPendingApprovals()
    },
    methods: {
        ...mapActions(useApprovalStore, ['reduceCountPendingApproval']),
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getPendingApprovals(){
            this.isTableLoading = true
            axios.get(services.approval + 'approvals', {headers: getHeader()})
            .then(res => {
                this.tableData = res.data.data
                this.allApprovals = this.tableData
                const countStatus = (status) => this.allApprovals.filter(approval => approval.appr_final_status === status).length

                this.productsApprovals = this.tableData.filter(product => product.appr_related_type === 'product')
                this.commissionApprovals = this.tableData.filter(product => product.appr_related_type === 'case_recognizes')

                this.totalApprovalStatus.all = this.allApprovals.length
                this.totalApprovalStatus.pending = countStatus(null)
                this.totalApprovalStatus.approved = countStatus(1)
                this.totalApprovalStatus.rejected = countStatus(0)
                this.isTableLoading = false
                if(!this.is_first_load){
                    this.reduceCountPendingApproval()
                }else{
                    this.is_first_load = false
                }
            })
            .catch(e => {
                this.errorFunction(e)
                this.isTableLoading = false
            })
        },
        previewValue(approval_type){
            if(approval_type === 'PROPTY_APPROVAL'){
                this.$refs.pendingApprovalCaseModal.toggleView(true)
            }
            if(approval_type === 'PL_APPROVAL'){
                this.$refs.pendingApprovalPersonalLoanModal.toggleView(true)
            }
            if(approval_type === 'MTG_APPROVAL'){
                this.$refs.pendingApprovalMortgageLoanModal.toggleView(true)
            }
            if(approval_type === 'INS_APPROVAL'){
                this.$refs.pendingApprovalInsuranceModal.toggleView(true)
            }
            if(approval_type === 'REF_APPROVAL'){
                this.$refs.pendingApprovalRefinanceModal.toggleView(true)
            }
            if(approval_type === 'OTH_LOAN_APPROVAL'){
                this.$refs.pendingApprovalOtherLoanModal.toggleView(true)
            }
            if(approval_type === 'SOL_APPROVAL'){
                this.$refs.pendingApprovalSolicitorModal.toggleView(true)
            }
            if(approval_type === 'HUB_COMMS_PAYOUT_SUMMARY_APPROVAL'){
                this.openView();
                this.decide_mode = false;
            }
        },
        previewApproval(approval){
            this.current_approval = approval
            this.$refs.previewApprovalModal.toggleView()
        },
        decideApproval(approval){
            this.current_approval = approval
            if(this.current_approval.approval_type === 'PROPTY_APPROVAL'){
                this.$refs.pendingApprovalCaseModal.toggleView(false)
            }
            if(this.current_approval.approval_type === 'PL_APPROVAL'){
                this.$refs.pendingApprovalPersonalLoanModal.toggleView(false)
            }
            if(this.current_approval.approval_type === 'INS_APPROVAL'){
                this.$refs.pendingApprovalInsuranceModal.toggleView(false)
            }
            if(this.current_approval.approval_type === 'MTG_APPROVAL'){
                this.$refs.pendingApprovalMortgageLoanModal.toggleView(false)
            }
            if(this.current_approval.approval_type === 'REF_APPROVAL'){
                this.$refs.pendingApprovalRefinanceModal.toggleView(false)
            }
            if(this.current_approval.approval_type === 'OTH_LOAN_APPROVAL'){
                this.$refs.pendingApprovalOtherLoanModal.toggleView(false)
            }
            if(this.current_approval.approval_type === 'SOL_APPROVAL'){
                this.$refs.pendingApprovalSolicitorModal.toggleView(false)
            }
            if(this.current_approval.approval_type === 'HUB_COMMS_PAYOUT_SUMMARY_APPROVAL'){
                this.openView();
                this.getPermissionSetting();
            }
        },
        cancelCase(approval) {
            this.current_approval = approval
            this.$refs.cancelApprovalHubCommsPayoutSummaryModal.toggleView(false)
        },
        // hub comms payout function
        openView() {
            this.modals.showDirectPayoutDetails = true;
            this.current_view = this.current_approval;
            if(Array.isArray(this.current_approval.appr_req_value))
            {
                this.current_comms_payout_summaries = this.current_approval.appr_req_value[0];
            }
            else
            {
                this.current_comms_payout_summaries = this.current_approval.appr_req_value;
            }
            this.comms_payout_summaries = this.current_approval.appr_req_value;
            // overwrite all button
            // this.decide_mode = false;
        },
        getPermissionSetting() {
            this.decide_mode = true;
            // this.checkIsAdmin();
            if(!this.permission.admin)
            {
                this.checkIsAcceptor();
                this.checkIsReviewer();
                this.checkIsApprover();
            }
        },
        checkIsAcceptor() {
            if(this.auth_user.id == this.current_approval.appr_req_value[0].hub.hub_manager.id && this.current_approval.approval_reviewers[0].appr_rev_user_id == this.auth_user.id && this.current_approval.approval_reviewers[0].appr_rev_status === null)
            {
                this.permission.acceptor = true;
            }
            else
            {
                this.permission.acceptor = false;
            }
        },
        checkIsReviewer() {
            axios.get(services.hub + 'hub_comms/hub_pending_approval.check_is_reviewer/COMMS_PAYOUT_SUMMARY', { headers: getHeader() })
            .then(res => {
                if(res.data == 1)
                {
                    this.permission.reviewer = true;
                }
                else
                {
                    this.permission.reviewer = false;
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Checking is reviewer function failed: " + error.response.data.message) 
            });
        },
        checkIsApprover() {
            axios.get(services.hub + 'hub_comms/hub_pending_approval.check_is_approver/COMMS_PAYOUT_SUMMARY', { headers: getHeader() })
            .then(res => {
                if(res.data == 1)
                {
                    if(this.permission.acceptor)
                    {
                        this.permission.approver = false;
                    }
                    else
                    {
                        this.permission.approver = true;
                    }
                }
                else
                {
                    this.permission.approver = false;
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Checking is approver function failed: " + error.response.data.message) 
            });
        },
        checkIsAdmin() {
            if(_gHlp.checkRoleType( ['admin', 'corporate']))
            {
                this.permission.admin = true;
            }
            else
            {
                this.permission.admin = false;
            }
        },
        getUpdatedCommsPayoutSummaries(updatedData) {
            this.current_comms_payout_summaries = updatedData[0];
            this.comms_payout_summaries = updatedData;
        },
        groupingReviewers(approvalReviewers) {
            const grouped_status = {};

            for (const key in approvalReviewers) {
                const item = approvalReviewers[key]

                switch(item.appr_rev_status)
                {
                    case 0:
                        grouped_status[item.app_rev_order] = 0
                        break;
                    case 1:
                        grouped_status[item.app_rev_order] = 1
                        break;
                    case 2:
                        grouped_status[item.app_rev_order] = 2
                        break;
                    case null:
                        if(grouped_status[item.app_rev_order] === undefined)
                        {
                            grouped_status[item.app_rev_order] = null
                        }
                        break;
                }
            }
            return Object.values(grouped_status)
        },
        getStatusClass(status) {
            if (status === null) {
                return 'bg-fintos'
            } else if (status === 1) {
                return 'bg-success'
            } else if (status === 0) {
                return 'bg-danger'
            }
            return ''
        },
        getStatusFill(status) {
            if (status === null) {
                return '#f3bc43'
            } else if (status === 1) {
                return '#2dce89'
            } else if (status === 0) {
                return '#f5365c'
            } else if (status === 2) {
                return '#00000'
            }
            return ''
        },
        getFilterStatusClass(status) {
            if (status === 'Pending') {
                return 'btn btn-outline-fintos'
            } else if (status === 'Approved') {
                return 'btn btn-outline-success'
            } else if (status === 'Rejected') {
                return 'btn btn-outline-danger'
            }
            return 'btn btn-outline-primary'
        },
        getReviewerName(index) {
            const reviewerNames = ['Operation', 'Sales', 'Top Management']
            return reviewerNames[index] || ''
        },
        getReviewerInitial(index) {
            const reviewerNames = ['O', 'S', 'TM'];
            return reviewerNames[index] || '';
        },
        getHubReviewerName(index) {
            const reviewerNames = ['Hub Management', 'Operation', 'Top Management']
            return reviewerNames[index] || ''
        },
        getHubReviewerInitial(index) {
            const reviewerNames = ['HB', 'O', 'TM']
            return reviewerNames[index] || ''
        },
        changeTable(tab) {
            this.activeTab = tab
            if (tab === 'all') {
                this.tableData = this.allApprovals
                this.selectFilterButton(tab)
            } else if (tab === 'cases') {
                this.tableData = this.productsApprovals
                this.selectFilterButton(tab)
            } else if (tab === 'revenue') {
                this.tableData = this.allApprovals
            } else if (tab === 'commission') {
                this.tableData = this.commissionApprovals
                this.selectFilterButton(tab)
            }
            this.selectedStatus = 'All'
        },
        selectFilterButton(button) {
            this.selectedStatus = button

            let tabArrays = {
                all: 'allApprovals',
                cases: 'productsApprovals',
                revenue: 'allApprovals',
                commission: 'commissionApprovals'
            }
            
            const tabArray = tabArrays[this.activeTab]

            if (tabArray) {
                this.tableData = this[tabArray].filter(product => {
                    if (button === 'Pending') {
                        return product.appr_final_status === null
                    } else if (button === 'Approved') {
                        return product.appr_final_status === 1
                    } else if (button === 'Rejected') {
                        return product.appr_final_status === 0
                    }
                    return true // Return true if no specific button is selected
                })

                const countStatus = (status) => this[tabArray].filter(approval => approval.appr_final_status === status).length

                this.totalApprovalStatus.all = this[tabArray].length
                this.totalApprovalStatus.pending = countStatus(null)
                this.totalApprovalStatus.approved = countStatus(1)
                this.totalApprovalStatus.rejected = countStatus(0)
            }
        },
    }
}
</script>